import { Component } from '@angular/core';
import { SidebarComponent } from '@core/components/sidebar/sidebar.component';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-layout',
  imports: [SidebarComponent, RouterOutlet],
  template: `
    <app-sidebar class="h-full">
      <router-outlet></router-outlet>
    </app-sidebar>
  `,
})
export class LayoutComponent {}
